export class NoticeSettings {
  constructor(overrides = {}) {
    const defaults = {
      width: { type: 'px', value: 600 },
      height: { type: 'auto', value: 1 },
      padding: { paddingLeft: 10, paddingRight: 10, paddingTop: 10, paddingBottom: 10 },
      border: { borderWidth: 0, borderColor: '#000000', borderTopLeftRadius: 10, borderTopRightRadius: 10, borderBottomLeftRadius: 10, borderBottomRightRadius: 10, borderStyle: 'solid' },
      background: '#ffffff',
      closeAlign: 'right',
      closeFont: { fontSize: 16, fontWeight: '500', color: '#999999', fontFamily: 'arial, helvetica, sans-serif' },
      selected_privacy_manager: { type: null, data: {} },
      showClose: true,
      showVeil: true,
      lockScroll: true,
      useSafeArea: false,
      veilColor: '#000000',
      veilOpacity: 0.65,
      type: 'modal',
      zIndex: 2147483000,
      url: '',
      type_settings: { targetType: 'id', targetName: '', dismissable: false },
      defaultLanguage: overrides.language || 'EN',
      useBrowserDefault: false,
      supportedLanguages: [],
      iframeTitle: 'SP Consent Message',
    };
    Object.assign(this, defaults, overrides);
  }
}

export const NoticeTypes = {
  privacy_manager: {
    selected_privacy_manager: { title: 'Privacy Manager', type: 'ChoiceOptions', customOptions: { restrictChoiceOption: true }},
    iframeTitle: { title: 'Text', type: 'TextLanguage' },
  },
  language: {
    defaultLanguage: { title: 'Default Language', type: 'Language' },
    useBrowserDefault: { title: 'Use Browser Default', type: 'Switch' },
  },
  settings: {
    type: { title: 'Message Type', type: 'Type' },
    lockScroll: { title: 'Disable Scrolling?', type: 'Switch' },
    useSafeArea: { title: 'Constrain Message to mobile safe area?', type: 'Switch' },
    zIndex: { title: 'Z-Index', type: 'ZIndex' },
    url: { title: 'Website BG', type: 'Input' },
  },
  orientation: {
    width: { title: 'Width', type: 'Size' },
    height: { title: 'Height', type: 'Size' },
    padding: { title: 'Padding', type: 'Padding' },
  },
  styles: {
    background: { title: 'Background Color', type: 'ColorPicker' },
    border: { title: 'Border', type: 'Border' },
  },
  close: {
    showClose: { title: 'Show?', type: 'Switch' },
    closeAlign: { title: 'Align', type: 'Align' },
    closeFont: { title: 'Style', type: 'Font' },
  },
  veil: {
    showVeil: { title: 'Show?', type: 'Switch' },
    veilColor: { title: 'Color', type: 'ColorPicker' },
    veilOpacity: { title: 'Opacity', type: 'Opacity' },
  },
};